/* The eligibility stage's shared pieces: the rule-8 summary and the "can't open" state. */
import { pickedLegs } from '@delaybuddy/contract';
import { useGo } from '../../app/navigation';
import type { ScreenId } from '../../app/registry';
import { Button, Note, Question, Summary } from '../../components';
import { useT } from '../../i18n';
import type { Enquiry, Trip } from '../../lib/api';
import { startNewCheck } from '../../lib/funnel';
import { formatDate } from '../../lib/format';

/** Rule 8: the route/date/flight card with its edit link (S3 → S1, S4–S6 → S3). */
export function TripSummary({ enquiry, trip, editTo }: { enquiry?: Enquiry; trip: Trip; editTo: ScreenId }) {
  const t = useT();
  const go = useGo();
  const idents = enquiry
    ? pickedLegs(enquiry)
        .map((l) => l.flight?.operatingIdent ?? l.manualIdent)
        .filter(Boolean)
    : [];
  const route = `${trip.origin?.iata ?? '—'} → ${trip.destination?.iata ?? '—'}`;
  const via = trip.connections.map((c) => c.iata);
  const meta = [formatDate(trip.date), via.length ? t('S1.summary.via', { via: via.join(', ') }) : '']
    .filter(Boolean)
    .join(' · ');
  return (
    <Summary
      line={idents.length ? `${route} · ${idents.join(', ')}` : route}
      meta={meta}
      onEdit={() => go(editTo)}
      editLabel={t(editTo === 'S1' ? 'S1.summary.editRoute' : 'S1.summary.editFlight')}
    />
  );
}

/**
 * The enquiry could not be read (a 403 from another browser's check, a lost session).
 * DRAFT copy: neither the prototype nor ux-flow.md has this state.
 */
export function StageError() {
  const t = useT();
  const go = useGo();
  return (
    <>
      <Question>{t('S1.stageError.title')}</Question>
      <Note>{t('S1.stageError.body')}</Note>
      <Button
        onClick={() => {
          startNewCheck();
          go('S1');
        }}
      >
        {t('S1.stageError.cta')}
      </Button>
    </>
  );
}
